



























































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import router from '@/router';
import Product from "@/types/app/products";
import UserInterface from "@/types/app/IUser";
import { getFund } from "@/utils/getFund";
import { getProduct } from '@/utils/getProduct';
import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import moment from "moment";
import Endpoint from "@/utils/endpoint";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import { itemsShowOnCard } from "@/constants/product";
import ErrorService from "@/services/erroService";

const namespace = "customer";

interface ProductArea {
  description: string;
  area: string;
}

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

@Component({
  data: () => ({
    formType: "",
    required: (v: any) => !!v || "This field is required",
  }),
  methods: {
    formatMoney,
    formatDate,
  },
  watch: {
    "$route.query.type": {
      handler: function(type) {
        this.$data.formType = type;
      },
      deep: true,
      immediate: true,
    },
  },
})
export default class ProductForm extends Vue {
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;
  @Action("setProductSent", { namespace: 'product' }) setProductSent!: any;

  @Action('addNewProduct', { namespace: 'product' }) addNewProduct!: (
    product: Product
  ) => void;
  
  private endpoint = new Endpoint();
  id: any;
  items: VuetifySelectItems[] = [];
  funds: VuetifySelectItems[] = [];
  files = [];
  status = ["Open", "Performing"];
  domiciles = ["US", "NON-US", "ALL"];
  formType = "";
  product: any = {
    attachments: [],
    showCard: [],
  };
  showCard = itemsShowOnCard;

  video: any;
  background: any;
  loading = false;
  fromDateMenu = false;
  fromDateMenuInceptionDate = false;
  fromDateMenuRasied = false;
  productSentLoading = false;

  valid = true;

  handleWithSelectedItensByInput(items: any) {
    if (this.likesAllItems(items.showCard)) {
      items.showCard = [];
    } else {
      items.showCard = this.showCard.slice();
    }
  }

  likesAllItems(selecteds: Array<string>) {
    return selecteds.length === this.showCard.length;
  }

  likesSomeItems(selecteds: Array<string>) {
    return selecteds.length > 0 && !this.likesAllItems(selecteds);
  }

  icon(value: Array<string>) {
    if (this.likesAllItems(value)) return "mdi-close-box";
    if (this.likesSomeItems(value)) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  async mounted() {
    try {
      this.loading = true;
      const itemsForVuetifySelect = await this.getProductAreas();
      this.items = itemsForVuetifySelect;

      const fundsForVuetifySelect = await this.getProductFunds();
      this.funds = fundsForVuetifySelect;
      this.loading = false;
    } catch (error) {
      ErrorService.onError({ status: -1, message: 'Products:New:Mounted', error });
      this.loading = false;
    }
  }

  getBackgraound() {
    const image: File = this.background;

    this.product.backgroundImage = image;
  }

  getFiles() {
    const files: ReadonlyArray<File> = [...(this.files ? this.files : [])];

    files.forEach((file) => {
      this.product.attachments.push(file);
    });
  }

  getVideos() {
    const video: File = this.video;
    this.product.attachments.push(video);
  }

  async getProductAreas(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productAreas;
    const response = await this.$http.get(url);
    const productAreas = response.data as ProductArea[];
    const productAreasOrdened = productAreas.sort((a, b) => {
      if (a.description < b.description) {
        return -1;
      }
      if (b.description < a.description) {
        return 1;
      }
      return 0;
    });

    const itemsForVuetifySelect = productAreasOrdened.map((productArea) => ({
      text: productArea.description,
      value: productArea.description,
    }));

    return itemsForVuetifySelect;
  }

  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(url);
    const productFunds = response.data as ProductFund[];
    const productFundsOrdened = productFunds.sort((a, b) => {
      if (a.fundSiteName < b.fundSiteName) {
        return -1;
      }
      if (b.fundSiteName < a.fundSiteName) {
        return 1;
      }
      return 0;
    });

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
    }));

    return itemsForVuetifySelect;
  }

  async uploadFile(response: any, element: any) {
    const url = this.endpoint.productFile;

    const formData = new FormData();

    formData.append("file", element);

    await this.$http.post(`${url}/${response.productId}`, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  }

  async uploadBackground(response: any) {
    const formData = new FormData();

    const url = this.endpoint.productBackground;
    formData.append("file", this.product.backgroundImage);

    await this.$http.post(`${url}/${response.productId}`, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  }

  openExternalLink(link: string): void {
    window.open(link, "_blank");
  }

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  closeModal(): void {
    this.setProductSent(false);
    router.push({
      name: 'Products'
    });
  }

  async makeNewProduct() {
    if (!this.form.validate()) {
      return false;
    }

    this.product.showCard = String(this.product.showCard);

    try {
      const url = this.endpoint.productCreate;
      this.productSentLoading = true;

      const response = await this.$http.post(url, this.product);

      if (response) {
        this.uploadBackground(response);

        if (this.product.attachments.length) {
          this.product.attachments.forEach(async (element: any) => {
            await this.uploadFile(response, element);
          });
        }

        this.productSentLoading = false;

        this.showProductSentModal(response);
        this.clearFields();
      }
    } catch (error) {
      ErrorService.onError({ status: -1, message: 'Products:New:MakeNewProduct', error });
    } finally {
      this.productSentLoading = false;
    }
  }

  showProductSentModal(response: any) {
    this.setProductSent(true);
    this.$router.push({
      name: "ProductDetail",
      params: {
        productId: response.productId,
      },
      query: { type: "view" },
    });
  }

  async getProductData(response:any) {
    const endpoint = new Endpoint();

    this.loading = true;

    try {
      const res = await getProduct(
        endpoint.product,
        response.productId,
        this.$http
      );

      this.addNewProduct(res); 
      
    } catch (error) {
     ErrorService.onError({ status: -1, message: 'Products:New:getProductData', error });
    } finally {
      this.loading = false;
    }
  }

  async onSelectedFund(fundId: any) {
    try {
      this.loading = true;
      const fundResponse = await getFund(
        this.endpoint.productFundById,
        fundId,
        this.$http
      );

      this.product.raised = fundResponse.fundInfo.raiseDate;
      this.product.minimalInvestment = fundResponse.fundInfo.minInvestment || 0;
      this.product.fees =
        `Penalty Fee: ${fundResponse.fundInfo.penaltyFee}\n` +
        `Administration Fee: ${fundResponse.fundInfo.administrationFee}\n` +
        `Performance Fee: ${fundResponse.fundInfo.performanceFee}`;
      this.product.returnSinceInception =
        fundResponse.fundPerformance.vlProfitHistorical;
      this.product.strategyAUM = fundResponse.fundPerformance.vlAUMStrategy;
      this.product.lastMonthPerformance =
        fundResponse.fundPerformance.vlProfitLastMonth;
      this.product.ytdPerformance =
        fundResponse.fundPerformance.vlProfitLastYear;
      
    } catch (error) {
      ErrorService.onError({ status: -1, message: 'Products:New:onSelectedFund', error });
      
    }finally{
      this.loading = false;
    }
  }

  clearFields() {
    this.product = {};
  }
}
